import React from 'react';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import FooterWrapper from './FooterWrapper';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import InstagramIcon from '@mui/icons-material/Instagram';
import PropTypes from 'prop-types';

const currentYear = new Date().getFullYear();

const AppFooter = ({ socialSettings, customer }) => {
  const slug = customer?.customer_slug;
  const capitalizedSlug = slug
    ? slug.charAt(0).toUpperCase() + slug.slice(1)
    : '';
  return (
    <FooterWrapper className='footer'>
      <div
        className='footerContainer'
        style={{ justifyContent: 'space-between' }}
      >
        <Typography>
          {' '}
          © {currentYear} {capitalizedSlug}. All Rights Reserved.{' '}
        </Typography>
        <Box className='top-social' style={{ display: 'none' }}>
          <Button size='small'>
            <FacebookIcon
              onClick={() => {
                window.open(socialSettings?.facebook, '_blank');
              }}
            />
          </Button>
          <Button size='small'>
            <XIcon
              onClick={() => {
                window.open(socialSettings?.twitter, '_blank');
              }}
            />
          </Button>
          <Button
            size='small'
            onClick={() => {
              window.open(socialSettings?.slack, '_blank');
            }}
          >
            <img
              src='/assets/images/slack-logo.svg'
              alt='slack-new'
              style={{ width: '28px', filter: 'contrast(0.4)' }}
            />
          </Button>
          {socialSettings?.instagram && (
            <Button size='small'>
              <InstagramIcon
                onClick={() => {
                  window.open(socialSettings?.instagram, '_blank');
                }}
              />
            </Button>
          )}
        </Box>
      </div>
    </FooterWrapper>
  );
};

export default AppFooter;
AppFooter.propTypes = {
  socialSettings: PropTypes.object,
  customer: PropTypes.object,
};
